// src/data/ciudadesColombia.js - municipios de Colombia
const CIUDADES = [
  { ciudad: 'El Encanto', departamento: 'Amazonas' },
  { ciudad: 'La Chorrera', departamento: 'Amazonas' },
  { ciudad: 'La Pedrera', departamento: 'Amazonas' },
  { ciudad: 'La Victoria', departamento: 'Amazonas' },
  { ciudad: 'Leticia', departamento: 'Amazonas' },
  { ciudad: 'Miriti - Paraná', departamento: 'Amazonas' },
  { ciudad: 'Puerto Alegria', departamento: 'Amazonas' },
  { ciudad: 'Puerto Arica', departamento: 'Amazonas' },
  { ciudad: 'Puerto Nariño', departamento: 'Amazonas' },
  { ciudad: 'Puerto Santander', departamento: 'Amazonas' },
  { ciudad: 'Tarapacá', departamento: 'Amazonas' },
  { ciudad: 'Abejorral', departamento: 'Antioquia' },
  { ciudad: 'Abriaquí', departamento: 'Antioquia' },
  { ciudad: 'Alejandría', departamento: 'Antioquia' },
  { ciudad: 'Amaga', departamento: 'Antioquia' },
  { ciudad: 'Amalfi', departamento: 'Antioquia' },
  { ciudad: 'Andes', departamento: 'Antioquia' },
  { ciudad: 'Angelopolis', departamento: 'Antioquia' },
  { ciudad: 'Angostura', departamento: 'Antioquia' },
  { ciudad: 'Anorí', departamento: 'Antioquia' },
  { ciudad: 'Anza', departamento: 'Antioquia' },
  { ciudad: 'Apartadó', departamento: 'Antioquia' },
  { ciudad: 'Arboletes', departamento: 'Antioquia' },
  { ciudad: 'Argelia', departamento: 'Antioquia' },
  { ciudad: 'Armenia', departamento: 'Antioquia' },
  { ciudad: 'Barbosa', departamento: 'Antioquia' },
  { ciudad: 'Bello', departamento: 'Antioquia' },
  { ciudad: 'Belmira', departamento: 'Antioquia' },
  { ciudad: 'Betania', departamento: 'Antioquia' },
  { ciudad: 'Betulia', departamento: 'Antioquia' },
  { ciudad: 'Briceño', departamento: 'Antioquia' },
  { ciudad: 'Buriticá', departamento: 'Antioquia' },
  { ciudad: 'Caicedo', departamento: 'Antioquia' },
  { ciudad: 'Caldas', departamento: 'Antioquia' },
  { ciudad: 'Campamento', departamento: 'Antioquia' },
  { ciudad: 'Caracolí', departamento: 'Antioquia' },
  { ciudad: 'Caramanta', departamento: 'Antioquia' },
  { ciudad: 'Carepa', departamento: 'Antioquia' },
  { ciudad: 'Carmen De Viboral', departamento: 'Antioquia' },
  { ciudad: 'Carolina', departamento: 'Antioquia' },
  { ciudad: 'Caucasia', departamento: 'Antioquia' },
  { ciudad: 'Cañasgordas', departamento: 'Antioquia' },
  { ciudad: 'Chigorodó', departamento: 'Antioquia' },
  { ciudad: 'Cisneros', departamento: 'Antioquia' },
  { ciudad: 'Ciudad Bolívar', departamento: 'Antioquia' },
  { ciudad: 'Cocorná', departamento: 'Antioquia' },
  { ciudad: 'Concepción', departamento: 'Antioquia' },
  { ciudad: 'Concordia', departamento: 'Antioquia' },
  { ciudad: 'Copacabana', departamento: 'Antioquia' },
  { ciudad: 'Cáceres', departamento: 'Antioquia' },
  { ciudad: 'Dabeiba', departamento: 'Antioquia' },
  { ciudad: 'Don Matias', departamento: 'Antioquia' },
  { ciudad: 'Ebéjico', departamento: 'Antioquia' },
  { ciudad: 'El Bagre', departamento: 'Antioquia' },
  { ciudad: 'Entrerrios', departamento: 'Antioquia' },
  { ciudad: 'Envigado', departamento: 'Antioquia' },
  { ciudad: 'Fredonia', departamento: 'Antioquia' },
  { ciudad: 'Frontino', departamento: 'Antioquia' },
  { ciudad: 'Giraldo', departamento: 'Antioquia' },
  { ciudad: 'Girardota', departamento: 'Antioquia' },
  { ciudad: 'Granada', departamento: 'Antioquia' },
  { ciudad: 'Guadalupe', departamento: 'Antioquia' },
  { ciudad: 'Guarne', departamento: 'Antioquia' },
  { ciudad: 'Guatape', departamento: 'Antioquia' },
  { ciudad: 'Gómez Plata', departamento: 'Antioquia' },
  { ciudad: 'Heliconia', departamento: 'Antioquia' },
  { ciudad: 'Hispania', departamento: 'Antioquia' },
  { ciudad: 'Itagui', departamento: 'Antioquia' },
  { ciudad: 'Ituango', departamento: 'Antioquia' },
  { ciudad: 'Jardín', departamento: 'Antioquia' },
  { ciudad: 'Jericó', departamento: 'Antioquia' },
  { ciudad: 'La Ceja', departamento: 'Antioquia' },
  { ciudad: 'La Estrella', departamento: 'Antioquia' },
  { ciudad: 'La Pintada', departamento: 'Antioquia' },
  { ciudad: 'La Unión', departamento: 'Antioquia' },
  { ciudad: 'Liborina', departamento: 'Antioquia' },
  { ciudad: 'Maceo', departamento: 'Antioquia' },
  { ciudad: 'Marinilla', departamento: 'Antioquia' },
  { ciudad: 'Medellín', departamento: 'Antioquia' },
  { ciudad: 'Montebello', departamento: 'Antioquia' },
  { ciudad: 'Murindó', departamento: 'Antioquia' },
  { ciudad: 'Mutata', departamento: 'Antioquia' },
  { ciudad: 'Nariño', departamento: 'Antioquia' },
  { ciudad: 'Nechí', departamento: 'Antioquia' },
  { ciudad: 'Necoclí', departamento: 'Antioquia' },
  { ciudad: 'Olaya', departamento: 'Antioquia' },
  { ciudad: 'Peque', departamento: 'Antioquia' },
  { ciudad: 'Peñol', departamento: 'Antioquia' },
  { ciudad: 'Pueblorrico', departamento: 'Antioquia' },
  { ciudad: 'Puerto Berrio', departamento: 'Antioquia' },
  { ciudad: 'Puerto Nare', departamento: 'Antioquia' },
  { ciudad: 'Puerto Triunfo', departamento: 'Antioquia' },
  { ciudad: 'Remedios', departamento: 'Antioquia' },
  { ciudad: 'Retiro', departamento: 'Antioquia' },
  { ciudad: 'Rionegro', departamento: 'Antioquia' },
  { ciudad: 'Sabanalarga', departamento: 'Antioquia' },
  { ciudad: 'Sabaneta', departamento: 'Antioquia' },
  { ciudad: 'Salgar', departamento: 'Antioquia' },
  { ciudad: 'San Andrés', departamento: 'Antioquia' },
  { ciudad: 'San Carlos', departamento: 'Antioquia' },
  { ciudad: 'San Francisco', departamento: 'Antioquia' },
  { ciudad: 'San Jerónimo', departamento: 'Antioquia' },
  { ciudad: 'San José De La Montaña', departamento: 'Antioquia' },
  { ciudad: 'San Juan De Uraba', departamento: 'Antioquia' },
  { ciudad: 'San Luis', departamento: 'Antioquia' },
  { ciudad: 'San Pedro', departamento: 'Antioquia' },
  { ciudad: 'San Pedro De Uraba', departamento: 'Antioquia' },
  { ciudad: 'San Rafael', departamento: 'Antioquia' },
  { ciudad: 'San Roque', departamento: 'Antioquia' },
  { ciudad: 'San Vicente', departamento: 'Antioquia' },
  { ciudad: 'Santa Barbara', departamento: 'Antioquia' },
  { ciudad: 'Santa Rosa De Osos', departamento: 'Antioquia' },
  { ciudad: 'Santafé De Antioquia', departamento: 'Antioquia' },
  { ciudad: 'Santo Domingo', departamento: 'Antioquia' },
  { ciudad: 'Santuario', departamento: 'Antioquia' },
  { ciudad: 'Segovia', departamento: 'Antioquia' },
  { ciudad: 'Sonson', departamento: 'Antioquia' },
  { ciudad: 'Sopetran', departamento: 'Antioquia' },
  { ciudad: 'Tarazá', departamento: 'Antioquia' },
  { ciudad: 'Tarso', departamento: 'Antioquia' },
  { ciudad: 'Titiribí', departamento: 'Antioquia' },
  { ciudad: 'Toledo', departamento: 'Antioquia' },
  { ciudad: 'Turbo', departamento: 'Antioquia' },
  { ciudad: 'Támesis', departamento: 'Antioquia' },
  { ciudad: 'Uramita', departamento: 'Antioquia' },
  { ciudad: 'Urrao', departamento: 'Antioquia' },
  { ciudad: 'Valdivia', departamento: 'Antioquia' },
  { ciudad: 'Valparaiso', departamento: 'Antioquia' },
  { ciudad: 'Vegachí', departamento: 'Antioquia' },
  { ciudad: 'Venecia', departamento: 'Antioquia' },
  { ciudad: 'Vigía Del Fuerte', departamento: 'Antioquia' },
  { ciudad: 'Yalí', departamento: 'Antioquia' },
  { ciudad: 'Yarumal', departamento: 'Antioquia' },
  { ciudad: 'Yolombó', departamento: 'Antioquia' },
  { ciudad: 'Yondó', departamento: 'Antioquia' },
  { ciudad: 'Zaragoza', departamento: 'Antioquia' },
  { ciudad: 'Arauca', departamento: 'Arauca' },
  { ciudad: 'Arauquita', departamento: 'Arauca' },
  { ciudad: 'Cravo Norte', departamento: 'Arauca' },
  { ciudad: 'Fortul', departamento: 'Arauca' },
  { ciudad: 'Puerto Rondón', departamento: 'Arauca' },
  { ciudad: 'Saravena', departamento: 'Arauca' },
  { ciudad: 'Tame', departamento: 'Arauca' },
  { ciudad: 'Providencia Y Santa Catalina', departamento: 'Archipielago De San Andres' },
  { ciudad: 'San Andres', departamento: 'Archipielago De San Andres' },
  { ciudad: 'Baranoa', departamento: 'Atlántico' },
  { ciudad: 'Barranquilla', departamento: 'Atlántico' },
  { ciudad: 'Campo De La Cruz', departamento: 'Atlántico' },
  { ciudad: 'Candelaria', departamento: 'Atlántico' },
  { ciudad: 'Galapa', departamento: 'Atlántico' },
  { ciudad: 'Juan De Acosta', departamento: 'Atlántico' },
  { ciudad: 'Luruaco', departamento: 'Atlántico' },
  { ciudad: 'Malambo', departamento: 'Atlántico' },
  { ciudad: 'Manati', departamento: 'Atlántico' },
  { ciudad: 'Palmar De Varela', departamento: 'Atlántico' },
  { ciudad: 'Piojó', departamento: 'Atlántico' },
  { ciudad: 'Polonuevo', departamento: 'Atlántico' },
  { ciudad: 'Ponedera', departamento: 'Atlántico' },
  { ciudad: 'Puerto Colombia', departamento: 'Atlántico' },
  { ciudad: 'Repelon', departamento: 'Atlántico' },
  { ciudad: 'Sabanagrande', departamento: 'Atlántico' },
  { ciudad: 'Sabanalarga', departamento: 'Atlántico' },
  { ciudad: 'Santa Lucia', departamento: 'Atlántico' },
  { ciudad: 'Santo Tomas', departamento: 'Atlántico' },
  { ciudad: 'Soledad', departamento: 'Atlántico' },
  { ciudad: 'Suan', departamento: 'Atlántico' },
  { ciudad: 'Tubara', departamento: 'Atlántico' },
  { ciudad: 'Usiacuri', departamento: 'Atlántico' },
  { ciudad: 'Bogota D.C.', departamento: 'Bogotá D.C.' },
  { ciudad: 'Achí', departamento: 'Bolivar' },
  { ciudad: 'Altos Del Rosario', departamento: 'Bolivar' },
  { ciudad: 'Arenal', departamento: 'Bolivar' },
  { ciudad: 'Arjona', departamento: 'Bolivar' },
  { ciudad: 'Arroyohondo', departamento: 'Bolivar' },
  { ciudad: 'Barranco De Loba', departamento: 'Bolivar' },
  { ciudad: 'Calamar', departamento: 'Bolivar' },
  { ciudad: 'Cantagallo', departamento: 'Bolivar' },
  { ciudad: 'Carmen De Bolívar', departamento: 'Bolivar' },
  { ciudad: 'Cartagena', departamento: 'Bolivar' },
  { ciudad: 'Cicuco', departamento: 'Bolivar' },
  { ciudad: 'Clemencia', departamento: 'Bolivar' },
  { ciudad: 'Córdoba', departamento: 'Bolivar' },
  { ciudad: 'El Guamo', departamento: 'Bolivar' },
  { ciudad: 'El Peñon', departamento: 'Bolivar' },
  { ciudad: 'Hatillo De Loba', departamento: 'Bolivar' },
  { ciudad: 'Magangué', departamento: 'Bolivar' },
  { ciudad: 'Mahates', departamento: 'Bolivar' },
  { ciudad: 'Margarita', departamento: 'Bolivar' },
  { ciudad: 'María La Baja', departamento: 'Bolivar' },
  { ciudad: 'Mompós', departamento: 'Bolivar' },
  { ciudad: 'Montecristo', departamento: 'Bolivar' },
  { ciudad: 'Morales', departamento: 'Bolivar' },
  { ciudad: 'Pinillos', departamento: 'Bolivar' },
  { ciudad: 'Regidor', departamento: 'Bolivar' },
  { ciudad: 'Río Viejo', departamento: 'Bolivar' },
  { ciudad: 'San Cristobal', departamento: 'Bolivar' },
  { ciudad: 'San Estanislao', departamento: 'Bolivar' },
  { ciudad: 'San Fernando', departamento: 'Bolivar' },
  { ciudad: 'San Jacinto', departamento: 'Bolivar' },
  { ciudad: 'San Jacinto Del Cauca', departamento: 'Bolivar' },
  { ciudad: 'San Juan Nepomuceno', departamento: 'Bolivar' },
  { ciudad: 'San Martin De Loba', departamento: 'Bolivar' },
  { ciudad: 'San Pablo', departamento: 'Bolivar' },
  { ciudad: 'Santa Catalina', departamento: 'Bolivar' },
  { ciudad: 'Santa Rosa De Lima', departamento: 'Bolivar' },
  { ciudad: 'Santa Rosa Del Sur', departamento: 'Bolivar' },
  { ciudad: 'Simití', departamento: 'Bolivar' },
  { ciudad: 'Soplaviento', departamento: 'Bolivar' },
  { ciudad: 'Talaigua Nuevo', departamento: 'Bolivar' },
  { ciudad: 'Tiquisio', departamento: 'Bolivar' },
  { ciudad: 'Turbaco', departamento: 'Bolivar' },
  { ciudad: 'Turbana', departamento: 'Bolivar' },
  { ciudad: 'Villanueva', departamento: 'Bolivar' },
  { ciudad: 'Zambrano', departamento: 'Bolivar' },
  { ciudad: 'Almeida', departamento: 'Boyacá' },
  { ciudad: 'Aquitania', departamento: 'Boyacá' },
  { ciudad: 'Arcabuco', departamento: 'Boyacá' },
  { ciudad: 'Belén', departamento: 'Boyacá' },
  { ciudad: 'Berbeo', departamento: 'Boyacá' },
  { ciudad: 'Betéitiva', departamento: 'Boyacá' },
  { ciudad: 'Boavita', departamento: 'Boyacá' },
  { ciudad: 'Boyacá', departamento: 'Boyacá' },
  { ciudad: 'Briceño', departamento: 'Boyacá' },
  { ciudad: 'Buenavista', departamento: 'Boyacá' },
  { ciudad: 'Busbanzá', departamento: 'Boyacá' },
  { ciudad: 'Caldas', departamento: 'Boyacá' },
  { ciudad: 'Campohermoso', departamento: 'Boyacá' },
  { ciudad: 'Cerinza', departamento: 'Boyacá' },
  { ciudad: 'Chinavita', departamento: 'Boyacá' },
  { ciudad: 'Chiquinquirá', departamento: 'Boyacá' },
  { ciudad: 'Chiscas', departamento: 'Boyacá' },
  { ciudad: 'Chita', departamento: 'Boyacá' },
  { ciudad: 'Chitaraque', departamento: 'Boyacá' },
  { ciudad: 'Chivatá', departamento: 'Boyacá' },
  { ciudad: 'Chivor', departamento: 'Boyacá' },
  { ciudad: 'Chíquiza', departamento: 'Boyacá' },
  { ciudad: 'Ciénega', departamento: 'Boyacá' },
  { ciudad: 'Coper', departamento: 'Boyacá' },
  { ciudad: 'Corrales', departamento: 'Boyacá' },
  { ciudad: 'Covarachía', departamento: 'Boyacá' },
  { ciudad: 'Cubará', departamento: 'Boyacá' },
  { ciudad: 'Cucaita', departamento: 'Boyacá' },
  { ciudad: 'Cuítiva', departamento: 'Boyacá' },
  { ciudad: 'Cómbita', departamento: 'Boyacá' },
  { ciudad: 'Duitama', departamento: 'Boyacá' },
  { ciudad: 'El Cocuy', departamento: 'Boyacá' },
  { ciudad: 'El Espino', departamento: 'Boyacá' },
  { ciudad: 'Firavitoba', departamento: 'Boyacá' },
  { ciudad: 'Floresta', departamento: 'Boyacá' },
  { ciudad: 'Gachantivá', departamento: 'Boyacá' },
  { ciudad: 'Gameza', departamento: 'Boyacá' },
  { ciudad: 'Garagoa', departamento: 'Boyacá' },
  { ciudad: 'Guacamayas', departamento: 'Boyacá' },
  { ciudad: 'Guateque', departamento: 'Boyacá' },
  { ciudad: 'Guayatá', departamento: 'Boyacá' },
  { ciudad: 'Güicán', departamento: 'Boyacá' },
  { ciudad: 'Iza', departamento: 'Boyacá' },
  { ciudad: 'Jenesano', departamento: 'Boyacá' },
  { ciudad: 'Jericó', departamento: 'Boyacá' },
  { ciudad: 'La Capilla', departamento: 'Boyacá' },
  { ciudad: 'La Uvita', departamento: 'Boyacá' },
  { ciudad: 'La Victoria', departamento: 'Boyacá' },
  { ciudad: 'Labranzagrande', departamento: 'Boyacá' },
  { ciudad: 'Macanal', departamento: 'Boyacá' },
  { ciudad: 'Maripí', departamento: 'Boyacá' },
  { ciudad: 'Miraflores', departamento: 'Boyacá' },
  { ciudad: 'Mongua', departamento: 'Boyacá' },
  { ciudad: 'Monguí', departamento: 'Boyacá' },
  { ciudad: 'Moniquirá', departamento: 'Boyacá' },
  { ciudad: 'Motavita', departamento: 'Boyacá' },
  { ciudad: 'Muzo', departamento: 'Boyacá' },
  { ciudad: 'Nobsa', departamento: 'Boyacá' },
  { ciudad: 'Nuevo Colón', departamento: 'Boyacá' },
  { ciudad: 'Oicatá', departamento: 'Boyacá' },
  { ciudad: 'Otanche', departamento: 'Boyacá' },
  { ciudad: 'Pachavita', departamento: 'Boyacá' },
  { ciudad: 'Paipa', departamento: 'Boyacá' },
  { ciudad: 'Pajarito', departamento: 'Boyacá' },
  { ciudad: 'Panqueba', departamento: 'Boyacá' },
  { ciudad: 'Pauna', departamento: 'Boyacá' },
  { ciudad: 'Paya', departamento: 'Boyacá' },
  { ciudad: 'Paz De Río', departamento: 'Boyacá' },
  { ciudad: 'Pesca', departamento: 'Boyacá' },
  { ciudad: 'Pisba', departamento: 'Boyacá' },
  { ciudad: 'Puerto Boyaca', departamento: 'Boyacá' },
  { ciudad: 'Páez', departamento: 'Boyacá' },
  { ciudad: 'Quípama', departamento: 'Boyacá' },
  { ciudad: 'Ramiriquí', departamento: 'Boyacá' },
  { ciudad: 'Rondón', departamento: 'Boyacá' },
  { ciudad: 'Ráquira', departamento: 'Boyacá' },
  { ciudad: 'Saboyá', departamento: 'Boyacá' },
  { ciudad: 'Samacá', departamento: 'Boyacá' },
  { ciudad: 'San Eduardo', departamento: 'Boyacá' },
  { ciudad: 'San José De Pare', departamento: 'Boyacá' },
  { ciudad: 'San Luis De Gaceno', departamento: 'Boyacá' },
  { ciudad: 'San Mateo', departamento: 'Boyacá' },
  { ciudad: 'San Miguel De Sema', departamento: 'Boyacá' },
  { ciudad: 'San Pablo Borbur', departamento: 'Boyacá' },
  { ciudad: 'San Rosa Viterbo', departamento: 'Boyacá' },
  { ciudad: 'Santa María', departamento: 'Boyacá' },
  { ciudad: 'Santa Sofía', departamento: 'Boyacá' },
  { ciudad: 'Santana', departamento: 'Boyacá' },
  { ciudad: 'Sativanorte', departamento: 'Boyacá' },
  { ciudad: 'Sativasur', departamento: 'Boyacá' },
  { ciudad: 'Siachoque', departamento: 'Boyacá' },
  { ciudad: 'Soatá', departamento: 'Boyacá' },
  { ciudad: 'Socha', departamento: 'Boyacá' },
  { ciudad: 'Socotá', departamento: 'Boyacá' },
  { ciudad: 'Sogamoso', departamento: 'Boyacá' },
  { ciudad: 'Somondoco', departamento: 'Boyacá' },
  { ciudad: 'Sora', departamento: 'Boyacá' },
  { ciudad: 'Soracá', departamento: 'Boyacá' },
  { ciudad: 'Sotaquirá', departamento: 'Boyacá' },
  { ciudad: 'Susacón', departamento: 'Boyacá' },
  { ciudad: 'Sutamarchán', departamento: 'Boyacá' },
  { ciudad: 'Sutatenza', departamento: 'Boyacá' },
  { ciudad: 'Sáchica', departamento: 'Boyacá' },
  { ciudad: 'Tasco', departamento: 'Boyacá' },
  { ciudad: 'Tenza', departamento: 'Boyacá' },
  { ciudad: 'Tibaná', departamento: 'Boyacá' },
  { ciudad: 'Tibasosa', departamento: 'Boyacá' },
  { ciudad: 'Tinjacá', departamento: 'Boyacá' },
  { ciudad: 'Tipacoque', departamento: 'Boyacá' },
  { ciudad: 'Toca', departamento: 'Boyacá' },
  { ciudad: 'Togüí', departamento: 'Boyacá' },
  { ciudad: 'Tota', departamento: 'Boyacá' },
  { ciudad: 'Tunja', departamento: 'Boyacá' },
  { ciudad: 'Tununguá', departamento: 'Boyacá' },
  { ciudad: 'Turmequé', departamento: 'Boyacá' },
  { ciudad: 'Tuta', departamento: 'Boyacá' },
  { ciudad: 'Tutazá', departamento: 'Boyacá' },
  { ciudad: 'Tópaga', departamento: 'Boyacá' },
  { ciudad: 'Umbita', departamento: 'Boyacá' },
  { ciudad: 'Ventaquemada', departamento: 'Boyacá' },
  { ciudad: 'Villa De Leyva', departamento: 'Boyacá' },
  { ciudad: 'Viracachá', departamento: 'Boyacá' },
  { ciudad: 'Zetaquira', departamento: 'Boyacá' },
  { ciudad: 'Aguadas', departamento: 'Caldas' },
  { ciudad: 'Anserma', departamento: 'Caldas' },
  { ciudad: 'Aranzazu', departamento: 'Caldas' },
  { ciudad: 'Belalcázar', departamento: 'Caldas' },
  { ciudad: 'Chinchina', departamento: 'Caldas' },
  { ciudad: 'Filadelfia', departamento: 'Caldas' },
  { ciudad: 'La Dorada', departamento: 'Caldas' },
  { ciudad: 'La Merced', departamento: 'Caldas' },
  { ciudad: 'Manizales', departamento: 'Caldas' },
  { ciudad: 'Manzanares', departamento: 'Caldas' },
  { ciudad: 'Marmato', departamento: 'Caldas' },
  { ciudad: 'Marquetalia', departamento: 'Caldas' },
  { ciudad: 'Marulanda', departamento: 'Caldas' },
  { ciudad: 'Neira', departamento: 'Caldas' },
  { ciudad: 'Norcasia', departamento: 'Caldas' },
  { ciudad: 'Palestina', departamento: 'Caldas' },
  { ciudad: 'Pensilvania', departamento: 'Caldas' },
  { ciudad: 'Pácora', departamento: 'Caldas' },
  { ciudad: 'Riosucio', departamento: 'Caldas' },
  { ciudad: 'Risaralda', departamento: 'Caldas' },
  { ciudad: 'Salamina', departamento: 'Caldas' },
  { ciudad: 'Samaná', departamento: 'Caldas' },
  { ciudad: 'San José', departamento: 'Caldas' },
  { ciudad: 'Supía', departamento: 'Caldas' },
  { ciudad: 'Victoria', departamento: 'Caldas' },
  { ciudad: 'Villamaria', departamento: 'Caldas' },
  { ciudad: 'Viterbo', departamento: 'Caldas' },
  { ciudad: 'Albania', departamento: 'Caqueta' },
  { ciudad: 'Belén De Los Andaquies', departamento: 'Caqueta' },
  { ciudad: 'Cartagena Del Chairá', departamento: 'Caqueta' },
  { ciudad: 'Currillo', departamento: 'Caqueta' },
  { ciudad: 'El Doncello', departamento: 'Caqueta' },
  { ciudad: 'El Paujil', departamento: 'Caqueta' },
  { ciudad: 'Florencia', departamento: 'Caqueta' },
  { ciudad: 'La Montañita', departamento: 'Caqueta' },
  { ciudad: 'Milan', departamento: 'Caqueta' },
  { ciudad: 'Morelia', departamento: 'Caqueta' },
  { ciudad: 'Puerto Rico', departamento: 'Caqueta' },
  { ciudad: 'San Jose Del Fragua', departamento: 'Caqueta' },
  { ciudad: 'San Vicente Del Caguán', departamento: 'Caqueta' },
  { ciudad: 'Solano', departamento: 'Caqueta' },
  { ciudad: 'Solita', departamento: 'Caqueta' },
  { ciudad: 'Valparaiso', departamento: 'Caqueta' },
  { ciudad: 'Aguazul', departamento: 'Casanare' },
  { ciudad: 'Chameza', departamento: 'Casanare' },
  { ciudad: 'Hato Corozal', departamento: 'Casanare' },
  { ciudad: 'La Salina', departamento: 'Casanare' },
  { ciudad: 'Maní', departamento: 'Casanare' },
  { ciudad: 'Monterrey', departamento: 'Casanare' },
  { ciudad: 'Nunchía', departamento: 'Casanare' },
  { ciudad: 'Orocué', departamento: 'Casanare' },
  { ciudad: 'Paz De Ariporo', departamento: 'Casanare' },
  { ciudad: 'Pore', departamento: 'Casanare' },
  { ciudad: 'Recetor', departamento: 'Casanare' },
  { ciudad: 'Sabanalarga', departamento: 'Casanare' },
  { ciudad: 'San Luis De Palenque', departamento: 'Casanare' },
  { ciudad: 'Sácama', departamento: 'Casanare' },
  { ciudad: 'Tauramena', departamento: 'Casanare' },
  { ciudad: 'Trinidad', departamento: 'Casanare' },
  { ciudad: 'Támara', departamento: 'Casanare' },
  { ciudad: 'Villanueva', departamento: 'Casanare' },
  { ciudad: 'Yopal', departamento: 'Casanare' },
  { ciudad: 'Almaguer', departamento: 'Cauca' },
  { ciudad: 'Argelia', departamento: 'Cauca' },
  { ciudad: 'Balboa', departamento: 'Cauca' },
  { ciudad: 'Bolívar', departamento: 'Cauca' },
  { ciudad: 'Buenos Aires', departamento: 'Cauca' },
  { ciudad: 'Cajibío', departamento: 'Cauca' },
  { ciudad: 'Caldono', departamento: 'Cauca' },
  { ciudad: 'Caloto', departamento: 'Cauca' },
  { ciudad: 'Corinto', departamento: 'Cauca' },
  { ciudad: 'El Tambo', departamento: 'Cauca' },
  { ciudad: 'Florencia', departamento: 'Cauca' },
  { ciudad: 'Guapi', departamento: 'Cauca' },
  { ciudad: 'Inzá', departamento: 'Cauca' },
  { ciudad: 'Jambalo', departamento: 'Cauca' },
  { ciudad: 'La Sierra', departamento: 'Cauca' },
  { ciudad: 'La Vega', departamento: 'Cauca' },
  { ciudad: 'Lopez', departamento: 'Cauca' },
  { ciudad: 'Mercaderes', departamento: 'Cauca' },
  { ciudad: 'Miranda', departamento: 'Cauca' },
  { ciudad: 'Morales', departamento: 'Cauca' },
  { ciudad: 'Padilla', departamento: 'Cauca' },
  { ciudad: 'Paez', departamento: 'Cauca' },
  { ciudad: 'Patia', departamento: 'Cauca' },
  { ciudad: 'Piamonte', departamento: 'Cauca' },
  { ciudad: 'Piendamo', departamento: 'Cauca' },
  { ciudad: 'Popayán', departamento: 'Cauca' },
  { ciudad: 'Puerto Tejada', departamento: 'Cauca' },
  { ciudad: 'Purace', departamento: 'Cauca' },
  { ciudad: 'Rosas', departamento: 'Cauca' },
  { ciudad: 'San Sebastian', departamento: 'Cauca' },
  { ciudad: 'Santa Rosa', departamento: 'Cauca' },
  { ciudad: 'Santander De Quilichao', departamento: 'Cauca' },
  { ciudad: 'Silvia', departamento: 'Cauca' },
  { ciudad: 'Sotara', departamento: 'Cauca' },
  { ciudad: 'Suarez', departamento: 'Cauca' },
  { ciudad: 'Sucre', departamento: 'Cauca' },
  { ciudad: 'Timbio', departamento: 'Cauca' },
  { ciudad: 'Timbiqui', departamento: 'Cauca' },
  { ciudad: 'Toribio', departamento: 'Cauca' },
  { ciudad: 'Totoro', departamento: 'Cauca' },
  { ciudad: 'Villa Rica', departamento: 'Cauca' },
  { ciudad: 'Aguachica', departamento: 'Cesar' },
  { ciudad: 'Agustín Codazzi', departamento: 'Cesar' },
  { ciudad: 'Astrea', departamento: 'Cesar' },
  { ciudad: 'Becerril', departamento: 'Cesar' },
  { ciudad: 'Bosconia', departamento: 'Cesar' },
  { ciudad: 'Chimichagua', departamento: 'Cesar' },
  { ciudad: 'Chiriguana', departamento: 'Cesar' },
  { ciudad: 'Curumaní', departamento: 'Cesar' },
  { ciudad: 'El Copey', departamento: 'Cesar' },
  { ciudad: 'El Paso', departamento: 'Cesar' },
  { ciudad: 'Gamarra', departamento: 'Cesar' },
  { ciudad: 'González', departamento: 'Cesar' },
  { ciudad: 'La Gloria', departamento: 'Cesar' },
  { ciudad: 'La Jagua De Ibirico', departamento: 'Cesar' },
  { ciudad: 'La Paz', departamento: 'Cesar' },
  { ciudad: 'Manaure', departamento: 'Cesar' },
  { ciudad: 'Pailitas', departamento: 'Cesar' },
  { ciudad: 'Pelaya', departamento: 'Cesar' },
  { ciudad: 'Pueblo Bello', departamento: 'Cesar' },
  { ciudad: 'Río De Oro', departamento: 'Cesar' },
  { ciudad: 'San Alberto', departamento: 'Cesar' },
  { ciudad: 'San Diego', departamento: 'Cesar' },
  { ciudad: 'San Martín', departamento: 'Cesar' },
  { ciudad: 'Tamalameque', departamento: 'Cesar' },
  { ciudad: 'Valledupar', departamento: 'Cesar' },
  { ciudad: 'Acandí', departamento: 'Choco' },
  { ciudad: 'Alto Baudó', departamento: 'Choco' },
  { ciudad: 'Atrato', departamento: 'Choco' },
  { ciudad: 'Bagadó', departamento: 'Choco' },
  { ciudad: 'Bahía Solano', departamento: 'Choco' },
  { ciudad: 'Bajo Baudó', departamento: 'Choco' },
  { ciudad: 'Belén De Bajira', departamento: 'Choco' },
  { ciudad: 'Bojaya', departamento: 'Choco' },
  { ciudad: 'Canton De San Pablo', departamento: 'Choco' },
  { ciudad: 'Carmén Del Darién', departamento: 'Choco' },
  { ciudad: 'Certegui', departamento: 'Choco' },
  { ciudad: 'Condoto', departamento: 'Choco' },
  { ciudad: 'El Carmen De Atrato', departamento: 'Choco' },
  { ciudad: 'El Litoral Del San Juan', departamento: 'Choco' },
  { ciudad: 'Itsmina', departamento: 'Choco' },
  { ciudad: 'Juradó', departamento: 'Choco' },
  { ciudad: 'Lloró', departamento: 'Choco' },
  { ciudad: 'Medio Atrato', departamento: 'Choco' },
  { ciudad: 'Medio Baudó', departamento: 'Choco' },
  { ciudad: 'Medio San Juan', departamento: 'Choco' },
  { ciudad: 'Nuquí', departamento: 'Choco' },
  { ciudad: 'Nóvita', departamento: 'Choco' },
  { ciudad: 'Quibdó', departamento: 'Choco' },
  { ciudad: 'Rio Quito', departamento: 'Choco' },
  { ciudad: 'Riosucio', departamento: 'Choco' },
  { ciudad: 'Río Frío', departamento: 'Choco' },
  { ciudad: 'San José Del Palmar', departamento: 'Choco' },
  { ciudad: 'Sipí', departamento: 'Choco' },
  { ciudad: 'Tadó', departamento: 'Choco' },
  { ciudad: 'Unguía', departamento: 'Choco' },
  { ciudad: 'Union Panamericana', departamento: 'Choco' },
  { ciudad: 'Ayapel', departamento: 'Cordoba' },
  { ciudad: 'Buenavista', departamento: 'Cordoba' },
  { ciudad: 'Canalete', departamento: 'Cordoba' },
  { ciudad: 'Cereté', departamento: 'Cordoba' },
  { ciudad: 'Chimá', departamento: 'Cordoba' },
  { ciudad: 'Chinú', departamento: 'Cordoba' },
  { ciudad: 'Ciénaga De Oro', departamento: 'Cordoba' },
  { ciudad: 'Cotorra', departamento: 'Cordoba' },
  { ciudad: 'La Apartada', departamento: 'Cordoba' },
  { ciudad: 'Lorica', departamento: 'Cordoba' },
  { ciudad: 'Los Córdobas', departamento: 'Cordoba' },
  { ciudad: 'Momil', departamento: 'Cordoba' },
  { ciudad: 'Montelíbano', departamento: 'Cordoba' },
  { ciudad: 'Montería', departamento: 'Cordoba' },
  { ciudad: 'Moñitos', departamento: 'Cordoba' },
  { ciudad: 'Planeta Rica', departamento: 'Cordoba' },
  { ciudad: 'Pueblo Nuevo', departamento: 'Cordoba' },
  { ciudad: 'Puerto Escondido', departamento: 'Cordoba' },
  { ciudad: 'Puerto Libertador', departamento: 'Cordoba' },
  { ciudad: 'Purísima', departamento: 'Cordoba' },
  { ciudad: 'Sahagún', departamento: 'Cordoba' },
  { ciudad: 'San Andrés Sotavento', departamento: 'Cordoba' },
  { ciudad: 'San Antero', departamento: 'Cordoba' },
  { ciudad: 'San Bernardo Del Viento', departamento: 'Cordoba' },
  { ciudad: 'San Carlos', departamento: 'Cordoba' },
  { ciudad: 'San Pelayo', departamento: 'Cordoba' },
  { ciudad: 'Tierralta', departamento: 'Cordoba' },
  { ciudad: 'Valencia', departamento: 'Cordoba' },
  { ciudad: 'Agua De Dios', departamento: 'Cundinamarca' },
  { ciudad: 'Albán', departamento: 'Cundinamarca' },
  { ciudad: 'Anapoima', departamento: 'Cundinamarca' },
  { ciudad: 'Anolaima', departamento: 'Cundinamarca' },
  { ciudad: 'Apulo', departamento: 'Cundinamarca' },
  { ciudad: 'Arbeláez', departamento: 'Cundinamarca' },
  { ciudad: 'Beltrán', departamento: 'Cundinamarca' },
  { ciudad: 'Bituima', departamento: 'Cundinamarca' },
  { ciudad: 'Bojacá', departamento: 'Cundinamarca' },
  { ciudad: 'Cabrera', departamento: 'Cundinamarca' },
  { ciudad: 'Cachipay', departamento: 'Cundinamarca' },
  { ciudad: 'Cajicá', departamento: 'Cundinamarca' },
  { ciudad: 'Caparrapí', departamento: 'Cundinamarca' },
  { ciudad: 'Caqueza', departamento: 'Cundinamarca' },
  { ciudad: 'Carmen De Carupa', departamento: 'Cundinamarca' },
  { ciudad: 'Chaguaní', departamento: 'Cundinamarca' },
  { ciudad: 'Chipaque', departamento: 'Cundinamarca' },
  { ciudad: 'Choachí', departamento: 'Cundinamarca' },
  { ciudad: 'Chocontá', departamento: 'Cundinamarca' },
  { ciudad: 'Chía', departamento: 'Cundinamarca' },
  { ciudad: 'Cogua', departamento: 'Cundinamarca' },
  { ciudad: 'Cota', departamento: 'Cundinamarca' },
  { ciudad: 'Cucunubá', departamento: 'Cundinamarca' },
  { ciudad: 'El Colegio', departamento: 'Cundinamarca' },
  { ciudad: 'El Peñón', departamento: 'Cundinamarca' },
  { ciudad: 'El Rosal', departamento: 'Cundinamarca' },
  { ciudad: 'Facatativá', departamento: 'Cundinamarca' },
  { ciudad: 'Fomeque', departamento: 'Cundinamarca' },
  { ciudad: 'Fosca', departamento: 'Cundinamarca' },
  { ciudad: 'Funza', departamento: 'Cundinamarca' },
  { ciudad: 'Fusagasugá', departamento: 'Cundinamarca' },
  { ciudad: 'Fúquene', departamento: 'Cundinamarca' },
  { ciudad: 'Gachala', departamento: 'Cundinamarca' },
  { ciudad: 'Gachancipá', departamento: 'Cundinamarca' },
  { ciudad: 'Gacheta', departamento: 'Cundinamarca' },
  { ciudad: 'Gama', departamento: 'Cundinamarca' },
  { ciudad: 'Girardot', departamento: 'Cundinamarca' },
  { ciudad: 'Granada', departamento: 'Cundinamarca' },
  { ciudad: 'Guachetá', departamento: 'Cundinamarca' },
  { ciudad: 'Guaduas', departamento: 'Cundinamarca' },
  { ciudad: 'Guasca', departamento: 'Cundinamarca' },
  { ciudad: 'Guataquí', departamento: 'Cundinamarca' },
  { ciudad: 'Guatavita', departamento: 'Cundinamarca' },
  { ciudad: 'Guayabal De Siquima', departamento: 'Cundinamarca' },
  { ciudad: 'Guayabetal', departamento: 'Cundinamarca' },
  { ciudad: 'Gutiérrez', departamento: 'Cundinamarca' },
  { ciudad: 'Jerusalén', departamento: 'Cundinamarca' },
  { ciudad: 'Junín', departamento: 'Cundinamarca' },
  { ciudad: 'La Calera', departamento: 'Cundinamarca' },
  { ciudad: 'La Mesa', departamento: 'Cundinamarca' },
  { ciudad: 'La Palma', departamento: 'Cundinamarca' },
  { ciudad: 'La Peña', departamento: 'Cundinamarca' },
  { ciudad: 'La Vega', departamento: 'Cundinamarca' },
  { ciudad: 'Lenguazaque', departamento: 'Cundinamarca' },
  { ciudad: 'Macheta', departamento: 'Cundinamarca' },
  { ciudad: 'Madrid', departamento: 'Cundinamarca' },
  { ciudad: 'Manta', departamento: 'Cundinamarca' },
  { ciudad: 'Medina', departamento: 'Cundinamarca' },
  { ciudad: 'Mosquera', departamento: 'Cundinamarca' },
  { ciudad: 'Nariño', departamento: 'Cundinamarca' },
  { ciudad: 'Nemocon', departamento: 'Cundinamarca' },
  { ciudad: 'Nilo', departamento: 'Cundinamarca' },
  { ciudad: 'Nimaima', departamento: 'Cundinamarca' },
  { ciudad: 'Nocaima', departamento: 'Cundinamarca' },
  { ciudad: 'Pacho', departamento: 'Cundinamarca' },
  { ciudad: 'Paime', departamento: 'Cundinamarca' },
  { ciudad: 'Pandi', departamento: 'Cundinamarca' },
  { ciudad: 'Paratebueno', departamento: 'Cundinamarca' },
  { ciudad: 'Pasca', departamento: 'Cundinamarca' },
  { ciudad: 'Puerto Salgar', departamento: 'Cundinamarca' },
  { ciudad: 'Puli', departamento: 'Cundinamarca' },
  { ciudad: 'Quebradanegra', departamento: 'Cundinamarca' },
  { ciudad: 'Quetame', departamento: 'Cundinamarca' },
  { ciudad: 'Quipile', departamento: 'Cundinamarca' },
  { ciudad: 'Ricaurte', departamento: 'Cundinamarca' },
  { ciudad: 'San Antonio De Tequendama', departamento: 'Cundinamarca' },
  { ciudad: 'San Bernardo', departamento: 'Cundinamarca' },
  { ciudad: 'San Cayetano', departamento: 'Cundinamarca' },
  { ciudad: 'San Francisco', departamento: 'Cundinamarca' },
  { ciudad: 'San Juan De Río Seco', departamento: 'Cundinamarca' },
  { ciudad: 'Sasaima', departamento: 'Cundinamarca' },
  { ciudad: 'Sesquilé', departamento: 'Cundinamarca' },
  { ciudad: 'Sibaté', departamento: 'Cundinamarca' },
  { ciudad: 'Silvania', departamento: 'Cundinamarca' },
  { ciudad: 'Simijaca', departamento: 'Cundinamarca' },
  { ciudad: 'Soacha', departamento: 'Cundinamarca' },
  { ciudad: 'Sopó', departamento: 'Cundinamarca' },
  { ciudad: 'Subachoque', departamento: 'Cundinamarca' },
  { ciudad: 'Suesca', departamento: 'Cundinamarca' },
  { ciudad: 'Supatá', departamento: 'Cundinamarca' },
  { ciudad: 'Susa', departamento: 'Cundinamarca' },
  { ciudad: 'Sutatausa', departamento: 'Cundinamarca' },
  { ciudad: 'Tabio', departamento: 'Cundinamarca' },
  { ciudad: 'Tausa', departamento: 'Cundinamarca' },
  { ciudad: 'Tena', departamento: 'Cundinamarca' },
  { ciudad: 'Tenjo', departamento: 'Cundinamarca' },
  { ciudad: 'Tibacuy', departamento: 'Cundinamarca' },
  { ciudad: 'Tibirita', departamento: 'Cundinamarca' },
  { ciudad: 'Tocaima', departamento: 'Cundinamarca' },
  { ciudad: 'Tocancipá', departamento: 'Cundinamarca' },
  { ciudad: 'Topaipi', departamento: 'Cundinamarca' },
  { ciudad: 'Ubalá', departamento: 'Cundinamarca' },
  { ciudad: 'Ubaque', departamento: 'Cundinamarca' },
  { ciudad: 'Ubate', departamento: 'Cundinamarca' },
  { ciudad: 'Une', departamento: 'Cundinamarca' },
  { ciudad: 'Venecia', departamento: 'Cundinamarca' },
  { ciudad: 'Vergara', departamento: 'Cundinamarca' },
  { ciudad: 'Vianí', departamento: 'Cundinamarca' },
  { ciudad: 'Villagomez', departamento: 'Cundinamarca' },
  { ciudad: 'Villapinzón', departamento: 'Cundinamarca' },
  { ciudad: 'Villeta', departamento: 'Cundinamarca' },
  { ciudad: 'Viotá', departamento: 'Cundinamarca' },
  { ciudad: 'Yacopí', departamento: 'Cundinamarca' },
  { ciudad: 'Zipacon', departamento: 'Cundinamarca' },
  { ciudad: 'Zipaquirá', departamento: 'Cundinamarca' },
  { ciudad: 'Útica', departamento: 'Cundinamarca' },
  { ciudad: 'Barranco Mina', departamento: 'Guainia' },
  { ciudad: 'Cacahual', departamento: 'Guainia' },
  { ciudad: 'Inírida', departamento: 'Guainia' },
  { ciudad: 'La Guadalupe', departamento: 'Guainia' },
  { ciudad: 'Mapiripan', departamento: 'Guainia' },
  { ciudad: 'Morichal', departamento: 'Guainia' },
  { ciudad: 'Pana Pana', departamento: 'Guainia' },
  { ciudad: 'Puerto Colombia', departamento: 'Guainia' },
  { ciudad: 'San Felipe', departamento: 'Guainia' },
  { ciudad: 'Calamar', departamento: 'Guaviare' },
  { ciudad: 'El Retorno', departamento: 'Guaviare' },
  { ciudad: 'Miraflores', departamento: 'Guaviare' },
  { ciudad: 'San José Del Guaviare', departamento: 'Guaviare' },
  { ciudad: 'Acevedo', departamento: 'Huila' },
  { ciudad: 'Agrado', departamento: 'Huila' },
  { ciudad: 'Aipe', departamento: 'Huila' },
  { ciudad: 'Algeciras', departamento: 'Huila' },
  { ciudad: 'Altamira', departamento: 'Huila' },
  { ciudad: 'Baraya', departamento: 'Huila' },
  { ciudad: 'Campoalegre', departamento: 'Huila' },
  { ciudad: 'Colombia', departamento: 'Huila' },
  { ciudad: 'Elías', departamento: 'Huila' },
  { ciudad: 'Garzón', departamento: 'Huila' },
  { ciudad: 'Gigante', departamento: 'Huila' },
  { ciudad: 'Guadalupe', departamento: 'Huila' },
  { ciudad: 'Hobo', departamento: 'Huila' },
  { ciudad: 'Iquira', departamento: 'Huila' },
  { ciudad: 'Isnos', departamento: 'Huila' },
  { ciudad: 'La Argentina', departamento: 'Huila' },
  { ciudad: 'La Plata', departamento: 'Huila' },
  { ciudad: 'Neiva', departamento: 'Huila' },
  { ciudad: 'Nátaga', departamento: 'Huila' },
  { ciudad: 'Oporapa', departamento: 'Huila' },
  { ciudad: 'Paicol', departamento: 'Huila' },
  { ciudad: 'Palermo', departamento: 'Huila' },
  { ciudad: 'Palestina', departamento: 'Huila' },
  { ciudad: 'Pital', departamento: 'Huila' },
  { ciudad: 'Pitalito', departamento: 'Huila' },
  { ciudad: 'Rivera', departamento: 'Huila' },
  { ciudad: 'Saladoblanco', departamento: 'Huila' },
  { ciudad: 'San Agustín', departamento: 'Huila' },
  { ciudad: 'Santa María', departamento: 'Huila' },
  { ciudad: 'Suaza', departamento: 'Huila' },
  { ciudad: 'Tarqui', departamento: 'Huila' },
  { ciudad: 'Tello', departamento: 'Huila' },
  { ciudad: 'Teruel', departamento: 'Huila' },
  { ciudad: 'Tesalia', departamento: 'Huila' },
  { ciudad: 'Timaná', departamento: 'Huila' },
  { ciudad: 'Villavieja', departamento: 'Huila' },
  { ciudad: 'Yaguará', departamento: 'Huila' },
  { ciudad: 'Albania', departamento: 'La Guajira' },
  { ciudad: 'Barrancas', departamento: 'La Guajira' },
  { ciudad: 'Dibulla', departamento: 'La Guajira' },
  { ciudad: 'Distraccion', departamento: 'La Guajira' },
  { ciudad: 'El Molino', departamento: 'La Guajira' },
  { ciudad: 'Fonseca', departamento: 'La Guajira' },
  { ciudad: 'Hatonuevo', departamento: 'La Guajira' },
  { ciudad: 'La Jagua Del Pilar', departamento: 'La Guajira' },
  { ciudad: 'Maicao', departamento: 'La Guajira' },
  { ciudad: 'Manaure', departamento: 'La Guajira' },
  { ciudad: 'Riohacha', departamento: 'La Guajira' },
  { ciudad: 'San Juan Del Cesar', departamento: 'La Guajira' },
  { ciudad: 'Uribia', departamento: 'La Guajira' },
  { ciudad: 'Urumita', departamento: 'La Guajira' },
  { ciudad: 'Villanueva', departamento: 'La Guajira' },
  { ciudad: 'Algarrobo', departamento: 'Magdalena' },
  { ciudad: 'Aracataca', departamento: 'Magdalena' },
  { ciudad: 'Ariguaní', departamento: 'Magdalena' },
  { ciudad: 'Cerro San Antonio', departamento: 'Magdalena' },
  { ciudad: 'Chibolo', departamento: 'Magdalena' },
  { ciudad: 'Ciénaga', departamento: 'Magdalena' },
  { ciudad: 'Concordia', departamento: 'Magdalena' },
  { ciudad: 'El Banco', departamento: 'Magdalena' },
  { ciudad: 'El Piñon', departamento: 'Magdalena' },
  { ciudad: 'El Reten', departamento: 'Magdalena' },
  { ciudad: 'Fundacion', departamento: 'Magdalena' },
  { ciudad: 'Guamal', departamento: 'Magdalena' },
  { ciudad: 'Nueva Granada', departamento: 'Magdalena' },
  { ciudad: 'Pedraza', departamento: 'Magdalena' },
  { ciudad: 'Pijiño Del Carmen', departamento: 'Magdalena' },
  { ciudad: 'Pivijay', departamento: 'Magdalena' },
  { ciudad: 'Plato', departamento: 'Magdalena' },
  { ciudad: 'Pueblo Viejo', departamento: 'Magdalena' },
  { ciudad: 'Remolino', departamento: 'Magdalena' },
  { ciudad: 'Sabanas De San Angel', departamento: 'Magdalena' },
  { ciudad: 'Salamina', departamento: 'Magdalena' },
  { ciudad: 'San Sebastian De Buenavista', departamento: 'Magdalena' },
  { ciudad: 'San Zenon', departamento: 'Magdalena' },
  { ciudad: 'Santa Ana', departamento: 'Magdalena' },
  { ciudad: 'Santa Barbara De Pinto', departamento: 'Magdalena' },
  { ciudad: 'Santa Marta', departamento: 'Magdalena' },
  { ciudad: 'Sitionuevo', departamento: 'Magdalena' },
  { ciudad: 'Tenerife', departamento: 'Magdalena' },
  { ciudad: 'Zapayan', departamento: 'Magdalena' },
  { ciudad: 'Zona Bananera', departamento: 'Magdalena' },
  { ciudad: 'Acacias', departamento: 'Meta' },
  { ciudad: 'Barranca De Upia', departamento: 'Meta' },
  { ciudad: 'Cabuyaro', departamento: 'Meta' },
  { ciudad: 'Castilla La Nueva', departamento: 'Meta' },
  { ciudad: 'Cumaral', departamento: 'Meta' },
  { ciudad: 'El Calvario', departamento: 'Meta' },
  { ciudad: 'El Castillo', departamento: 'Meta' },
  { ciudad: 'El Dorado', departamento: 'Meta' },
  { ciudad: 'Fuente De Oro', departamento: 'Meta' },
  { ciudad: 'Granada', departamento: 'Meta' },
  { ciudad: 'Guamal', departamento: 'Meta' },
  { ciudad: 'La Macarena', departamento: 'Meta' },
  { ciudad: 'La Uribe', departamento: 'Meta' },
  { ciudad: 'Lejanías', departamento: 'Meta' },
  { ciudad: 'Mapiripan', departamento: 'Meta' },
  { ciudad: 'Mesetas', departamento: 'Meta' },
  { ciudad: 'Puerto Concordia', departamento: 'Meta' },
  { ciudad: 'Puerto Gaitán', departamento: 'Meta' },
  { ciudad: 'Puerto Lleras', departamento: 'Meta' },
  { ciudad: 'Puerto Lopez', departamento: 'Meta' },
  { ciudad: 'Puerto Rico', departamento: 'Meta' },
  { ciudad: 'Restrepo', departamento: 'Meta' },
  { ciudad: 'San Carlos Guaroa', departamento: 'Meta' },
  { ciudad: 'San Juan De Arama', departamento: 'Meta' },
  { ciudad: 'San Juanito', departamento: 'Meta' },
  { ciudad: 'San Luis De Cubarral', departamento: 'Meta' },
  { ciudad: 'San Martín', departamento: 'Meta' },
  { ciudad: 'Villavicencio', departamento: 'Meta' },
  { ciudad: 'Vista Hermosa', departamento: 'Meta' },
  { ciudad: 'Alban', departamento: 'Nariño' },
  { ciudad: 'Aldana', departamento: 'Nariño' },
  { ciudad: 'Ancuya', departamento: 'Nariño' },
  { ciudad: 'Arboleda', departamento: 'Nariño' },
  { ciudad: 'Barbacoas', departamento: 'Nariño' },
  { ciudad: 'Belen', departamento: 'Nariño' },
  { ciudad: 'Buesaco', departamento: 'Nariño' },
  { ciudad: 'Chachagui', departamento: 'Nariño' },
  { ciudad: 'Colon', departamento: 'Nariño' },
  { ciudad: 'Consaca', departamento: 'Nariño' },
  { ciudad: 'Contadero', departamento: 'Nariño' },
  { ciudad: 'Cuaspud', departamento: 'Nariño' },
  { ciudad: 'Cumbal', departamento: 'Nariño' },
  { ciudad: 'Cumbitara', departamento: 'Nariño' },
  { ciudad: 'Córdoba', departamento: 'Nariño' },
  { ciudad: 'El Charco', departamento: 'Nariño' },
  { ciudad: 'El Peñol', departamento: 'Nariño' },
  { ciudad: 'El Rosario', departamento: 'Nariño' },
  { ciudad: 'El Tablon De Gomez', departamento: 'Nariño' },
  { ciudad: 'El Tambo', departamento: 'Nariño' },
  { ciudad: 'Francisco Pizarro', departamento: 'Nariño' },
  { ciudad: 'Funes', departamento: 'Nariño' },
  { ciudad: 'Guachucal', departamento: 'Nariño' },
  { ciudad: 'Guaitarilla', departamento: 'Nariño' },
  { ciudad: 'Gualmatan', departamento: 'Nariño' },
  { ciudad: 'Iles', departamento: 'Nariño' },
  { ciudad: 'Imues', departamento: 'Nariño' },
  { ciudad: 'Ipiales', departamento: 'Nariño' },
  { ciudad: 'La Cruz', departamento: 'Nariño' },
  { ciudad: 'La Florida', departamento: 'Nariño' },
  { ciudad: 'La Llanada', departamento: 'Nariño' },
  { ciudad: 'La Tola', departamento: 'Nariño' },
  { ciudad: 'La Union', departamento: 'Nariño' },
  { ciudad: 'Leiva', departamento: 'Nariño' },
  { ciudad: 'Linares', departamento: 'Nariño' },
  { ciudad: 'Los Andes', departamento: 'Nariño' },
  { ciudad: 'Magui', departamento: 'Nariño' },
  { ciudad: 'Mallama', departamento: 'Nariño' },
  { ciudad: 'Mosquera', departamento: 'Nariño' },
  { ciudad: 'Nariño', departamento: 'Nariño' },
  { ciudad: 'Olaya Herrera', departamento: 'Nariño' },
  { ciudad: 'Ospina', departamento: 'Nariño' },
  { ciudad: 'Pasto', departamento: 'Nariño' },
  { ciudad: 'Policarpa', departamento: 'Nariño' },
  { ciudad: 'Potosí', departamento: 'Nariño' },
  { ciudad: 'Providencia', departamento: 'Nariño' },
  { ciudad: 'Puerres', departamento: 'Nariño' },
  { ciudad: 'Pupiales', departamento: 'Nariño' },
  { ciudad: 'Ricaurte', departamento: 'Nariño' },
  { ciudad: 'Roberto Payan', departamento: 'Nariño' },
  { ciudad: 'Samaniego', departamento: 'Nariño' },
  { ciudad: 'San Bernardo', departamento: 'Nariño' },
  { ciudad: 'San Lorenzo', departamento: 'Nariño' },
  { ciudad: 'San Pablo', departamento: 'Nariño' },
  { ciudad: 'San Pedro De Cartago', departamento: 'Nariño' },
  { ciudad: 'Sandoná', departamento: 'Nariño' },
  { ciudad: 'Santa Barbara', departamento: 'Nariño' },
  { ciudad: 'Santa Cruz', departamento: 'Nariño' },
  { ciudad: 'Sapuyes', departamento: 'Nariño' },
  { ciudad: 'Taminango', departamento: 'Nariño' },
  { ciudad: 'Tangua', departamento: 'Nariño' },
  { ciudad: 'Tumaco', departamento: 'Nariño' },
  { ciudad: 'Tuquerres', departamento: 'Nariño' },
  { ciudad: 'Yacuanquer', departamento: 'Nariño' },
  { ciudad: 'Abrego', departamento: 'Norte De Santander' },
  { ciudad: 'Arboledas', departamento: 'Norte De Santander' },
  { ciudad: 'Bochalema', departamento: 'Norte De Santander' },
  { ciudad: 'Bucarasica', departamento: 'Norte De Santander' },
  { ciudad: 'Cachirá', departamento: 'Norte De Santander' },
  { ciudad: 'Chinácota', departamento: 'Norte De Santander' },
  { ciudad: 'Chitagá', departamento: 'Norte De Santander' },
  { ciudad: 'Convención', departamento: 'Norte De Santander' },
  { ciudad: 'Cucutilla', departamento: 'Norte De Santander' },
  { ciudad: 'Cácota', departamento: 'Norte De Santander' },
  { ciudad: 'Cúcuta', departamento: 'Norte De Santander' },
  { ciudad: 'Durania', departamento: 'Norte De Santander' },
  { ciudad: 'El Carmen', departamento: 'Norte De Santander' },
  { ciudad: 'El Tarra', departamento: 'Norte De Santander' },
  { ciudad: 'El Zulia', departamento: 'Norte De Santander' },
  { ciudad: 'Gramalote', departamento: 'Norte De Santander' },
  { ciudad: 'Hacarí', departamento: 'Norte De Santander' },
  { ciudad: 'Herrán', departamento: 'Norte De Santander' },
  { ciudad: 'La Esperanza', departamento: 'Norte De Santander' },
  { ciudad: 'La Playa', departamento: 'Norte De Santander' },
  { ciudad: 'Labateca', departamento: 'Norte De Santander' },
  { ciudad: 'Los Patios', departamento: 'Norte De Santander' },
  { ciudad: 'Lourdes', departamento: 'Norte De Santander' },
  { ciudad: 'Mutiscua', departamento: 'Norte De Santander' },
  { ciudad: 'Ocaña', departamento: 'Norte De Santander' },
  { ciudad: 'Pamplona', departamento: 'Norte De Santander' },
  { ciudad: 'Pamplonita', departamento: 'Norte De Santander' },
  { ciudad: 'Puerto Santander', departamento: 'Norte De Santander' },
  { ciudad: 'Ragonvalia', departamento: 'Norte De Santander' },
  { ciudad: 'Salazar', departamento: 'Norte De Santander' },
  { ciudad: 'San Calixto', departamento: 'Norte De Santander' },
  { ciudad: 'San Cayetano', departamento: 'Norte De Santander' },
  { ciudad: 'Santiago', departamento: 'Norte De Santander' },
  { ciudad: 'Sardinata', departamento: 'Norte De Santander' },
  { ciudad: 'Silos', departamento: 'Norte De Santander' },
  { ciudad: 'Teorama', departamento: 'Norte De Santander' },
  { ciudad: 'Tibú', departamento: 'Norte De Santander' },
  { ciudad: 'Toledo', departamento: 'Norte De Santander' },
  { ciudad: 'Villa Caro', departamento: 'Norte De Santander' },
  { ciudad: 'Villa Del Rosario', departamento: 'Norte De Santander' },
  { ciudad: 'Colón', departamento: 'Putumayo' },
  { ciudad: 'Mocoa', departamento: 'Putumayo' },
  { ciudad: 'Orito', departamento: 'Putumayo' },
  { ciudad: 'Puerto Asis', departamento: 'Putumayo' },
  { ciudad: 'Puerto Caicedo', departamento: 'Putumayo' },
  { ciudad: 'Puerto Guzman', departamento: 'Putumayo' },
  { ciudad: 'Puerto Leguizamo', departamento: 'Putumayo' },
  { ciudad: 'San Francisco', departamento: 'Putumayo' },
  { ciudad: 'San Miguel', departamento: 'Putumayo' },
  { ciudad: 'Santiago', departamento: 'Putumayo' },
  { ciudad: 'Sibundoy', departamento: 'Putumayo' },
  { ciudad: 'Valle Del Guamuez', departamento: 'Putumayo' },
  { ciudad: 'Villa Garzon', departamento: 'Putumayo' },
  { ciudad: 'Armenia', departamento: 'Quindio' },
  { ciudad: 'Buenavista', departamento: 'Quindio' },
  { ciudad: 'Calarca', departamento: 'Quindio' },
  { ciudad: 'Circasia', departamento: 'Quindio' },
  { ciudad: 'Cordoba', departamento: 'Quindio' },
  { ciudad: 'Filandia', departamento: 'Quindio' },
  { ciudad: 'Genova', departamento: 'Quindio' },
  { ciudad: 'La Tebaida', departamento: 'Quindio' },
  { ciudad: 'Montengro', departamento: 'Quindio' },
  { ciudad: 'Pijao', departamento: 'Quindio' },
  { ciudad: 'Quimbaya', departamento: 'Quindio' },
  { ciudad: 'Salento', departamento: 'Quindio' },
  { ciudad: 'Apía', departamento: 'Risaralda' },
  { ciudad: 'Balboa', departamento: 'Risaralda' },
  { ciudad: 'Belén De Umbría', departamento: 'Risaralda' },
  { ciudad: 'Dosquebradas', departamento: 'Risaralda' },
  { ciudad: 'Guática', departamento: 'Risaralda' },
  { ciudad: 'La Celia', departamento: 'Risaralda' },
  { ciudad: 'La Virginia', departamento: 'Risaralda' },
  { ciudad: 'Marsella', departamento: 'Risaralda' },
  { ciudad: 'Mistrató', departamento: 'Risaralda' },
  { ciudad: 'Pereira', departamento: 'Risaralda' },
  { ciudad: 'Pueblo Rico', departamento: 'Risaralda' },
  { ciudad: 'Quinchia', departamento: 'Risaralda' },
  { ciudad: 'Santa Rosa De Cabal', departamento: 'Risaralda' },
  { ciudad: 'Santuario', departamento: 'Risaralda' },
  { ciudad: 'Aguada', departamento: 'Santander' },
  { ciudad: 'Albania', departamento: 'Santander' },
  { ciudad: 'Aratoca', departamento: 'Santander' },
  { ciudad: 'Barbosa', departamento: 'Santander' },
  { ciudad: 'Barichara', departamento: 'Santander' },
  { ciudad: 'Barrancabermeja', departamento: 'Santander' },
  { ciudad: 'Betulia', departamento: 'Santander' },
  { ciudad: 'Bolívar', departamento: 'Santander' },
  { ciudad: 'Bucaramanga', departamento: 'Santander' },
  { ciudad: 'Cabrera', departamento: 'Santander' },
  { ciudad: 'California', departamento: 'Santander' },
  { ciudad: 'Capitanejo', departamento: 'Santander' },
  { ciudad: 'Carcasí', departamento: 'Santander' },
  { ciudad: 'Cepitá', departamento: 'Santander' },
  { ciudad: 'Cerrito', departamento: 'Santander' },
  { ciudad: 'Charalá', departamento: 'Santander' },
  { ciudad: 'Charta', departamento: 'Santander' },
  { ciudad: 'Chima', departamento: 'Santander' },
  { ciudad: 'Chipatá', departamento: 'Santander' },
  { ciudad: 'Cimitarra', departamento: 'Santander' },
  { ciudad: 'Concepción', departamento: 'Santander' },
  { ciudad: 'Confines', departamento: 'Santander' },
  { ciudad: 'Contratación', departamento: 'Santander' },
  { ciudad: 'Coromoro', departamento: 'Santander' },
  { ciudad: 'Curití', departamento: 'Santander' },
  { ciudad: 'El Carmen De Chucurí', departamento: 'Santander' },
  { ciudad: 'El Guacamayo', departamento: 'Santander' },
  { ciudad: 'El Peñón', departamento: 'Santander' },
  { ciudad: 'El Playón', departamento: 'Santander' },
  { ciudad: 'Encino', departamento: 'Santander' },
  { ciudad: 'Enciso', departamento: 'Santander' },
  { ciudad: 'Floridablanca', departamento: 'Santander' },
  { ciudad: 'Florián', departamento: 'Santander' },
  { ciudad: 'Galán', departamento: 'Santander' },
  { ciudad: 'Gambita', departamento: 'Santander' },
  { ciudad: 'Girón', departamento: 'Santander' },
  { ciudad: 'Guaca', departamento: 'Santander' },
  { ciudad: 'Guadalupe', departamento: 'Santander' },
  { ciudad: 'Guapotá', departamento: 'Santander' },
  { ciudad: 'Guavatá', departamento: 'Santander' },
  { ciudad: 'Guepsa', departamento: 'Santander' },
  { ciudad: 'Hato', departamento: 'Santander' },
  { ciudad: 'Jesús María', departamento: 'Santander' },
  { ciudad: 'Jordán', departamento: 'Santander' },
  { ciudad: 'La Belleza', departamento: 'Santander' },
  { ciudad: 'La Paz', departamento: 'Santander' },
  { ciudad: 'Landázuri', departamento: 'Santander' },
  { ciudad: 'Lebríja', departamento: 'Santander' },
  { ciudad: 'Los Santos', departamento: 'Santander' },
  { ciudad: 'Macaravita', departamento: 'Santander' },
  { ciudad: 'Matanza', departamento: 'Santander' },
  { ciudad: 'Mogotes', departamento: 'Santander' },
  { ciudad: 'Molagavita', departamento: 'Santander' },
  { ciudad: 'Málaga', departamento: 'Santander' },
  { ciudad: 'Ocamonte', departamento: 'Santander' },
  { ciudad: 'Oiba', departamento: 'Santander' },
  { ciudad: 'Onzaga', departamento: 'Santander' },
  { ciudad: 'Palmar', departamento: 'Santander' },
  { ciudad: 'Palmas Del Socorro', departamento: 'Santander' },
  { ciudad: 'Piedecuesta', departamento: 'Santander' },
  { ciudad: 'Pinchote', departamento: 'Santander' },
  { ciudad: 'Puente Nacional', departamento: 'Santander' },
  { ciudad: 'Puerto Parra', departamento: 'Santander' },
  { ciudad: 'Puerto Wilches', departamento: 'Santander' },
  { ciudad: 'Páramo', departamento: 'Santander' },
  { ciudad: 'Rionegro', departamento: 'Santander' },
  { ciudad: 'Sabana De Torres', departamento: 'Santander' },
  { ciudad: 'San Andrés', departamento: 'Santander' },
  { ciudad: 'San Benito', departamento: 'Santander' },
  { ciudad: 'San Gil', departamento: 'Santander' },
  { ciudad: 'San Joaquín', departamento: 'Santander' },
  { ciudad: 'San José De Miranda', departamento: 'Santander' },
  { ciudad: 'San Miguel', departamento: 'Santander' },
  { ciudad: 'San Vicente De Chucurí', departamento: 'Santander' },
  { ciudad: 'Santa Bárbara', departamento: 'Santander' },
  { ciudad: 'Santa Helena Del Opón', departamento: 'Santander' },
  { ciudad: 'Simacota', departamento: 'Santander' },
  { ciudad: 'Socorro', departamento: 'Santander' },
  { ciudad: 'Suaita', departamento: 'Santander' },
  { ciudad: 'Sucre', departamento: 'Santander' },
  { ciudad: 'Surata', departamento: 'Santander' },
  { ciudad: 'Tona', departamento: 'Santander' },
  { ciudad: 'Valle De San José', departamento: 'Santander' },
  { ciudad: 'Vetas', departamento: 'Santander' },
  { ciudad: 'Villanueva', departamento: 'Santander' },
  { ciudad: 'Vélez', departamento: 'Santander' },
  { ciudad: 'Zapatoca', departamento: 'Santander' },
  { ciudad: 'Buenavista', departamento: 'Sucre' },
  { ciudad: 'Caimito', departamento: 'Sucre' },
  { ciudad: 'Chalán', departamento: 'Sucre' },
  { ciudad: 'Coloso', departamento: 'Sucre' },
  { ciudad: 'Corozal', departamento: 'Sucre' },
  { ciudad: 'Coveñas', departamento: 'Sucre' },
  { ciudad: 'El Roble', departamento: 'Sucre' },
  { ciudad: 'Galeras', departamento: 'Sucre' },
  { ciudad: 'Guaranda', departamento: 'Sucre' },
  { ciudad: 'La Unión', departamento: 'Sucre' },
  { ciudad: 'Los Palmitos', departamento: 'Sucre' },
  { ciudad: 'Majagual', departamento: 'Sucre' },
  { ciudad: 'Morroa', departamento: 'Sucre' },
  { ciudad: 'Ovejas', departamento: 'Sucre' },
  { ciudad: 'Palmito', departamento: 'Sucre' },
  { ciudad: 'Sampués', departamento: 'Sucre' },
  { ciudad: 'San Benito Abad', departamento: 'Sucre' },
  { ciudad: 'San Juan Betulia', departamento: 'Sucre' },
  { ciudad: 'San Marcos', departamento: 'Sucre' },
  { ciudad: 'San Onofre', departamento: 'Sucre' },
  { ciudad: 'San Pedro', departamento: 'Sucre' },
  { ciudad: 'Santiago De Tolú', departamento: 'Sucre' },
  { ciudad: 'Sincelejo', departamento: 'Sucre' },
  { ciudad: 'Sincé', departamento: 'Sucre' },
  { ciudad: 'Sucre', departamento: 'Sucre' },
  { ciudad: 'Tolú Viejo', departamento: 'Sucre' },
  { ciudad: 'Alpujarra', departamento: 'Tolima' },
  { ciudad: 'Alvarado', departamento: 'Tolima' },
  { ciudad: 'Ambalema', departamento: 'Tolima' },
  { ciudad: 'Anzoátegui', departamento: 'Tolima' },
  { ciudad: 'Armero', departamento: 'Tolima' },
  { ciudad: 'Ataco', departamento: 'Tolima' },
  { ciudad: 'Cajamarca', departamento: 'Tolima' },
  { ciudad: 'Carmen De Apicalá', departamento: 'Tolima' },
  { ciudad: 'Casabianca', departamento: 'Tolima' },
  { ciudad: 'Chaparral', departamento: 'Tolima' },
  { ciudad: 'Coello', departamento: 'Tolima' },
  { ciudad: 'Coyaima', departamento: 'Tolima' },
  { ciudad: 'Cunday', departamento: 'Tolima' },
  { ciudad: 'Dolores', departamento: 'Tolima' },
  { ciudad: 'Espinal', departamento: 'Tolima' },
  { ciudad: 'Falan', departamento: 'Tolima' },
  { ciudad: 'Flandes', departamento: 'Tolima' },
  { ciudad: 'Fresno', departamento: 'Tolima' },
  { ciudad: 'Guamo', departamento: 'Tolima' },
  { ciudad: 'Herveo', departamento: 'Tolima' },
  { ciudad: 'Honda', departamento: 'Tolima' },
  { ciudad: 'Ibague', departamento: 'Tolima' },
  { ciudad: 'Icononzo', departamento: 'Tolima' },
  { ciudad: 'Lerida', departamento: 'Tolima' },
  { ciudad: 'Libano', departamento: 'Tolima' },
  { ciudad: 'Mariquita', departamento: 'Tolima' },
  { ciudad: 'Melgar', departamento: 'Tolima' },
  { ciudad: 'Murillo', departamento: 'Tolima' },
  { ciudad: 'Natagaima', departamento: 'Tolima' },
  { ciudad: 'Ortega', departamento: 'Tolima' },
  { ciudad: 'Palocabildo', departamento: 'Tolima' },
  { ciudad: 'Piedras', departamento: 'Tolima' },
  { ciudad: 'Planadas', departamento: 'Tolima' },
  { ciudad: 'Prado', departamento: 'Tolima' },
  { ciudad: 'Purificación', departamento: 'Tolima' },
  { ciudad: 'Rioblanco', departamento: 'Tolima' },
  { ciudad: 'Roncesvalles', departamento: 'Tolima' },
  { ciudad: 'Rovira', departamento: 'Tolima' },
  { ciudad: 'Saldaña', departamento: 'Tolima' },
  { ciudad: 'San Antonio', departamento: 'Tolima' },
  { ciudad: 'San Luis', departamento: 'Tolima' },
  { ciudad: 'Santa Isabel', departamento: 'Tolima' },
  { ciudad: 'Suárez', departamento: 'Tolima' },
  { ciudad: 'Valle De San Juan', departamento: 'Tolima' },
  { ciudad: 'Venadillo', departamento: 'Tolima' },
  { ciudad: 'Villahermosa', departamento: 'Tolima' },
  { ciudad: 'Villarrica', departamento: 'Tolima' },
  { ciudad: 'Alcala', departamento: 'Valle Del Cauca' },
  { ciudad: 'Andalucía', departamento: 'Valle Del Cauca' },
  { ciudad: 'Ansermanuevo', departamento: 'Valle Del Cauca' },
  { ciudad: 'Argelia', departamento: 'Valle Del Cauca' },
  { ciudad: 'Bolívar', departamento: 'Valle Del Cauca' },
  { ciudad: 'Buenaventura', departamento: 'Valle Del Cauca' },
  { ciudad: 'Buga', departamento: 'Valle Del Cauca' },
  { ciudad: 'Bugalagrande', departamento: 'Valle Del Cauca' },
  { ciudad: 'Caicedonia', departamento: 'Valle Del Cauca' },
  { ciudad: 'Cali', departamento: 'Valle Del Cauca' },
  { ciudad: 'Calima', departamento: 'Valle Del Cauca' },
  { ciudad: 'Candelaria', departamento: 'Valle Del Cauca' },
  { ciudad: 'Cartago', departamento: 'Valle Del Cauca' },
  { ciudad: 'Dagua', departamento: 'Valle Del Cauca' },
  { ciudad: 'El Cairo', departamento: 'Valle Del Cauca' },
  { ciudad: 'El Cerrito', departamento: 'Valle Del Cauca' },
  { ciudad: 'El Dovio', departamento: 'Valle Del Cauca' },
  { ciudad: 'El Águila', departamento: 'Valle Del Cauca' },
  { ciudad: 'Florida', departamento: 'Valle Del Cauca' },
  { ciudad: 'Ginebra', departamento: 'Valle Del Cauca' },
  { ciudad: 'Guacarí', departamento: 'Valle Del Cauca' },
  { ciudad: 'Jamundí', departamento: 'Valle Del Cauca' },
  { ciudad: 'La Cumbre', departamento: 'Valle Del Cauca' },
  { ciudad: 'La Unión', departamento: 'Valle Del Cauca' },
  { ciudad: 'La Victoria', departamento: 'Valle Del Cauca' },
  { ciudad: 'Obando', departamento: 'Valle Del Cauca' },
  { ciudad: 'Palmira', departamento: 'Valle Del Cauca' },
  { ciudad: 'Pradera', departamento: 'Valle Del Cauca' },
  { ciudad: 'Restrepo', departamento: 'Valle Del Cauca' },
  { ciudad: 'Riofrio', departamento: 'Valle Del Cauca' },
  { ciudad: 'Roldanillo', departamento: 'Valle Del Cauca' },
  { ciudad: 'San Pedro', departamento: 'Valle Del Cauca' },
  { ciudad: 'Sevilla', departamento: 'Valle Del Cauca' },
  { ciudad: 'Toro', departamento: 'Valle Del Cauca' },
  { ciudad: 'Trujillo', departamento: 'Valle Del Cauca' },
  { ciudad: 'Tuluá', departamento: 'Valle Del Cauca' },
  { ciudad: 'Ulloa', departamento: 'Valle Del Cauca' },
  { ciudad: 'Versalles', departamento: 'Valle Del Cauca' },
  { ciudad: 'Vijes', departamento: 'Valle Del Cauca' },
  { ciudad: 'Yotoco', departamento: 'Valle Del Cauca' },
  { ciudad: 'Yumbo', departamento: 'Valle Del Cauca' },
  { ciudad: 'Zarzal', departamento: 'Valle Del Cauca' },
  { ciudad: 'Caruru', departamento: 'Vaupes' },
  { ciudad: 'Mitú', departamento: 'Vaupes' },
  { ciudad: 'Pacoa', departamento: 'Vaupes' },
  { ciudad: 'Papunahua', departamento: 'Vaupes' },
  { ciudad: 'Taraira', departamento: 'Vaupes' },
  { ciudad: 'Yavaraté', departamento: 'Vaupes' },
  { ciudad: 'Cumaribo', departamento: 'Vichada' },
  { ciudad: 'La Primavera', departamento: 'Vichada' },
  { ciudad: 'Puerto Carreño', departamento: 'Vichada' },
  { ciudad: 'Santa Rosalía', departamento: 'Vichada' },
];

export default CIUDADES;
